import genericState from "@/store/generic/state";

import state from "@/store/customer/state";
import mutations from "@/store/customer/mutations";
import actions from "@/store/customer/actions";

export default {
  state() {
    return {
      ...genericState(),
      ...state,
    };
  },
  mutations: {
    ...mutations,
  },
  actions,
};
